module.exports = __webpack_public_path__ + "static/media/learnBlog.af47b733.svg";